import { useContext } from 'react';
import ExtractionBatchDocumentList from './ExtractionBatchDocumentList';
import DocumentViewDocumentModal from '../../documents/DocumentViewDocumentModal';
import { DocumentStateContext } from '../../../context/DocumentContext';

const ExtractionBatchDetails = () => {
  const { openViewDocumentModal } = useContext(DocumentStateContext);

  return (
    <>
      {/* <div style={{ marginTop: '10px', display: 'flex' }}>
        <div style={{ borderBottom: '1px solid green', width: '20px' }}></div>
        <a href="/details" style={{ textDecoration: 'none' }}>
          <div
            style={{
              border: '1px solid green',
              borderBottom: 'none',
              width: '60px',
              borderRadius: '5px 5px 0 0',
              textAlign: 'center',
              padding: '5px 0',
            }}
          >
            <Typography style={{ fontSize: '13px' }}>Details</Typography>
          </div>
        </a>
        <div style={{ borderBottom: '1px solid green', width: '5px' }}></div>
        <a href="/details" style={{ textDecoration: 'none' }}>
          <div
            style={{
              border: '1px solid green',
              borderBottom: 'none',
              width: '60px',
              borderRadius: '5px 5px 0 0',
              textAlign: 'center',
              padding: '5px',
            }}
          >
            <Typography style={{ fontSize: '13px' }}>Details</Typography>
          </div>
        </a>
        <div style={{ borderBottom: '1px solid green', width: '100%' }}></div>
      </div> */}
      <ExtractionBatchDocumentList />

      {openViewDocumentModal ? <DocumentViewDocumentModal /> : null}
    </>
  );
};
export default ExtractionBatchDetails;
